import { render, staticRenderFns } from "./OilinessLocationTemplate.vue?vue&type=template&id=13facc4d"
import script from "./OilinessLocationTemplate.vue?vue&type=script&lang=js"
export * from "./OilinessLocationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports